var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_11960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0.14209C11.2893 0.14209 0.14209 11.2893 0.14209 25C0.14209 38.7108 11.2893 49.858 25 49.858C38.7108 49.858 49.858 38.7108 49.858 25C49.858 11.2893 38.7108 0.14209 25 0.14209Z",
    fill: "#B72D2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9992 33.5543C26.0955 33.7981 25.1427 33.9284 24.1584 33.9284C18.3473 33.9284 13.6365 29.3859 13.6365 23.7823C13.6365 18.1788 18.3473 13.6362 24.1584 13.6362C29.9694 13.6362 34.6802 18.1788 34.6802 23.7823C34.6802 26.9837 33.1427 29.8388 30.7408 31.6983C31.4023 32.5038 32.1701 33.1275 33.0093 33.1275C34.3933 33.1275 34.8098 32.0533 34.845 31.5162H36.3637C36.3637 34.3594 34.6007 36.2654 31.7022 36.3561C30.6805 36.3881 28.9686 36.4416 26.9992 33.5543ZM26.0731 32.0013C25.518 32.1993 24.883 32.3051 24.1584 32.3051C19.8057 32.3051 18.687 28.4893 18.687 23.7823C18.687 19.0754 19.8067 15.2596 24.1584 15.2596C28.51 15.2596 29.6297 19.0754 29.6297 23.7823C29.6297 25.6927 29.4455 27.4563 28.9355 28.8775C28.1109 27.479 26.81 25.8116 24.4117 25.8116C22.4149 25.8116 20.8855 26.5999 20.3705 26.9941L21.0044 28.2155C21.1805 28.1592 21.6251 28.0466 21.9949 28.0466C22.4571 28.0466 24.0948 27.9037 25.6796 31.2173C25.8114 31.493 25.9427 31.7541 26.0731 32.0013Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_11960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuora);
export default __webpack_public_path__ + "static/media/Quora.e8c9ed229d4685d685005a7dd235495d.svg";
export { ForwardRef as ReactComponent };